var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "product-selector-wrapper" }, [
    _c(
      "div",
      { staticClass: "row justify-content-end align-items-center mb-3" },
      [
        _c("div", { staticClass: "col" }, [_vm._t("header-actions")], 2),
        _vm._v(" "),
        _c(
          "b-form",
          {
            staticClass: "col-auto fixed-content",
            attrs: { inline: "" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c("b-pagination", {
              staticClass: "mb-0",
              attrs: {
                size: "md",
                "total-rows": _setup.totalCount,
                "per-page": _setup.productsPerPage,
              },
              model: {
                value: _setup.currentPage,
                callback: function ($$v) {
                  _setup.currentPage = $$v
                },
                expression: "currentPage",
              },
            }),
            _vm._v(" "),
            _c("b-form-input", {
              staticClass: "ml-3",
              attrs: { placeholder: "Search", debounce: "400" },
              on: { update: _setup.updateSearchString },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list-group scrollable-content mb-3" },
      _vm._l(_setup.filteredProducts, function (product) {
        return _c(
          "div",
          {
            key: `product-${product.id}`,
            staticClass:
              "list-group-item product-item d-flex flex-wrap align-items-center justify-content-between",
            on: {
              click: function ($event) {
                return _setup.onProductSelect(product)
              },
            },
          },
          [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              product.image
                ? _c(
                    "div",
                    { staticClass: "product-img" },
                    [
                      _c(
                        "b-img",
                        _vm._b(
                          {
                            attrs: {
                              rounded: "",
                              thumbnail: "",
                              src: product.image,
                            },
                          },
                          "b-img",
                          _setup.thumbsProps,
                          false
                        )
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("strong", { staticClass: "ml-3" }, [
                _vm._v(_vm._s(product.title)),
              ]),
            ]),
            _vm._v(" "),
            _setup.selectedProducts.some((p) => p.id === product.id)
              ? _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: { variant: "danger" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _setup.onUnassign(product)
                          },
                        },
                      },
                      [_vm._v("Unassign")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }